Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = {
    container: {
        flex: 'none'
    }
};
